import { render, staticRenderFns } from "./UserMyNotifications.vue?vue&type=template&id=ec913d52"
import script from "./UserMyNotifications.vue?vue&type=script&lang=js"
export * from "./UserMyNotifications.vue?vue&type=script&lang=js"
import style0 from "./UserMyNotifications.vue?vue&type=style&index=0&id=ec913d52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports